const BASE_URL = "";
//window公测版
const WINDOW_DOWNLOAD_URL = "";
//window正式版
const WINDOW_OFFICIAL_DOWNLOAD_URL =
  "https://www.mpaidata.com/downloads/mpaidsp";
//window默认版
const WINDOW_MIAN_DOWNLOAD_URL = "https://www.mpaidata.com/downloads/mpaidsp";

//mac公测版
const OS_DOWNLOAD_URL = "#";
//mac正式版
const OS_OFFICIAL_DOWNLOAD_URL = "#";
//mac默认版
const OS_MIAN_DOWNLOAD_URL = "#";

export default {
  BASE_URL,
  WINDOW_DOWNLOAD_URL,
  WINDOW_OFFICIAL_DOWNLOAD_URL,
  WINDOW_MIAN_DOWNLOAD_URL,
  OS_DOWNLOAD_URL,
  OS_OFFICIAL_DOWNLOAD_URL,
  OS_MIAN_DOWNLOAD_URL
};
